module.exports = __webpack_public_path__ + "img/upload-file.9f3619ac.svg";